'use strict';

/**
 * @classname SelectSku
 * @classdesc SKU選択
 */
export default class SelectSku {
	/**
	 * @constructor
	 * @param {jQuery} $e - .select-sku
	 * @param {instance} controller - controllerオブジェクト
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._controller = controller;
		this._skuNo = $e.attr('data-sku-no');
		$e.on('change', () => this.onChange());
	};


	/**
	 * changeのコールバック
	 *
	 * @memberof SelectSku
	 * @return undefined
	 */
	onChange() {
		console.log(`${this.constructor.name}.onChange`);
		const $message = $('.text--select-sku');
		let sku, message;
		if(this._$e.val() === ''){
			// 値がない場合
			console.log('no value');
			$message.show();
			this._controller._item_stock_id = null;
			this.disabledButton();
		}else{
			// 値がある場合
			console.log('has value');
			const value = this._$e.val();
			if(this._controller._variationNum === 1){
				console.log('1軸');
				// skuが1軸の場合
				sku = `${value}_0`;
				if(stockInfo[sku].is_sold_out){
					// 選択したskuが売り切れの場合
					message = '<span class="text sold-out">売り切れ</span>';
					this.disabledButton();
					this._controller.soldOut();
				}else{
					// 選択したskuが売り切れでない場合
					message = stockInfo[sku].message || 'あり';
					this.activatedButton();
					const name = this._$e.find('option:selected').text();
					this._$e.closest('.dl').find('.dt span').text(name);
					this._controller._itemStockId = stockInfo[sku].item_stock_id;
				}
				$('.text--stock-message span').html(message);
			} else if(this._controller._variationNum === 2){
				console.log('2軸');
				// skuが2軸の場合
				const $otherSelect = (this._skuNo === '1') ? $('[data-sku-no=2]') : $('[data-sku-no=1]');
				// 反対側が値なしの場合
				const otherValue = $otherSelect.val();
				if(otherValue === '') {
					console.log('select only 1 sku');
					this.disabledButton();
					const name = this._$e.find('option:selected').text();
					this._$e.closest('.dl').find('.dt span').text(name);
				}else{
					console.log('select 2 sku');
					if(this._skuNo === '1'){
						sku = `${value}_${otherValue}`;
					}else{
						sku = `${otherValue}_${value}`;
					}
					if(stockInfo[sku].is_sold_out){
						console.log('sold out');
						this.disabledButton();
						const name = this._$e.find('option:selected').text();
						this._$e.closest('.dl').find('.dt span').text(name);
						message = '<span class="text sold-out">売り切れ</span>';
						$('.text--stock-message span').html(message);
					}else{
						console.log('available');
						message = stockInfo[sku].message || 'あり';
						this.activatedButton();
						$('.btn--add-cart').prop('disabled', false);
						const name = this._$e.find('option:selected').text();
						this._$e.closest('.dl').find('.dt span').text(name);
						$('.text--stock-message span').text(message);
						this._controller._itemStockId = stockInfo[sku].item_stock_id;
					}
				}
			}
		}
	};


	/**
	 * ボタン活性
	 *
	 * @memberof SelectSku
	 * @return undefined
	 */
	activatedButton() {
		console.log(`${this.constructor.name}.activatedButton`);
		$('.btn--add-cart').prop('disabled', false);
		$('.text--select-sku').hide();
		this._controller.notSoldOut();

	};


	/**
	 * ボタン非活性
	 *
	 * @memberof SelectSku
	 * @return undefined
	 */
	disabledButton() {
		console.log(`${this.constructor.name}.disabledButton`);
		$('.btn--add-cart').prop('disabled', true);
		$('.text--select-sku').show();
		this._controller._item_stock_id = null;
		this._$e.closest('.dl').find('.dt span').text('');
	};
};
